// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .sbscr .months-select {\n    display: grid;\n    width: 100%;\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto;\n  }\n\n@media (max-width: 730px) {\n    .root .sbscr .months-select {\n      gap: 5px;\n      grid-template-columns: repeat(3, 1fr);\n    }\n}\n", ""]);
// Exports
module.exports = exports;
